import React from 'react';
import styles from './image.module.scss';

type Props = {
    src: string;
    title: string;
    description?: string;
};

const Image = ({ title, src, description }: Props) => (
    <figure>
        <img src={src} alt={title} loading="lazy" />
        {description && (
            <figcaption className={styles.caption}>{description}</figcaption>
        )}
    </figure>
);

export default Image;
